import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { CALENDAR_DEFAULT_VIEW } from '../../../../sic-lib/defaults';
import { CalendarView } from '../../../../sic-lib/enums/CalendarView';
import { setCalendarView } from '../../../../store/calendar';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';

interface Props {
    anchorEl: HTMLElement | null;
    menuId: string;
    onCloseHandler: () => void;
}

export default function MenuCalendarViewRaw({ anchorEl, menuId, onCloseHandler }: Props) {
    const dispatch = useAppDispatch();

    const calendarView = useAppSelector(
        state => state.calendar?.calendarView || CALENDAR_DEFAULT_VIEW,
    );

    const handleSelect = (event: React.MouseEvent<HTMLElement>) => {
        const { view } = event.currentTarget.dataset;

        if (view) {
            //this madness casts a string back to the enum....
            const calendarViewEnum = CalendarView[view as keyof typeof CalendarView];

            dispatch(setCalendarView(calendarViewEnum));

            onCloseHandler();
        }
    };

    return (
        <Menu id={menuId} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onCloseHandler}>
            {Object.entries(CalendarView).map(([viewId, viewName]) => (
                <div key={viewId}>
                    <MenuItem
                        selected={calendarView === (viewId as CalendarView)}
                        data-view={viewId}
                        onClick={handleSelect}
                    >
                        {viewName}
                    </MenuItem>
                </div>
            ))}
        </Menu>
    );
}
